import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slice/userSlice";
import flaggedReducer from "./slice/flaggedSlice";
import globalReducer from "./slice/globalSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
    flagged: flaggedReducer,
    global: globalReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});

export default store;
